import { cn } from "@/lib/utils";
import { useState } from "react";

export function BrandMark({ className }: { className?: string }) {
  return (
    <svg
      aria-hidden="true"
      className={cn("size-6 shrink-0 text-primary", className)}
      viewBox="0 0 28 28"
    >
      <path
        d="M22 4H10a6 6 0 0 0-6 6v8a6 6 0 0 0 6 6h12v-5H11a2 2 0 0 1-2-2v-6a2 2 0 0 1 2-2h11V4Z"
        fill="currentColor"
      />
    </svg>
  );
}

export function Brand({
  className,
  compact = false,
  suppressFallback = false,
  workspace,
}: {
  className?: string;
  compact?: boolean;
  suppressFallback?: boolean;
  workspace?: {
    name: string;
    logoSrc: string;
  };
}) {
  const [failedLogoSrc, setFailedLogoSrc] = useState<string | null>(null);

  if (workspace && failedLogoSrc !== workspace.logoSrc) {
    return (
      <span
        aria-label={workspace.name}
        className={cn("inline-flex items-center", className)}
        role="img"
      >
        <img
          alt=""
          className="h-9 max-w-40 object-contain"
          onError={() => {
            setFailedLogoSrc(workspace.logoSrc);
          }}
          src={workspace.logoSrc}
        />
      </span>
    );
  }

  if (suppressFallback) {
    return <span aria-hidden="true" className={cn("inline-flex h-9 w-40", className)} />;
  }

  return (
    <span aria-label="CCBox" className={cn("inline-flex items-center gap-2", className)} role="img">
      <BrandMark />
      {!compact && (
        <span
          aria-hidden="true"
          className="font-heading text-[22px] leading-none font-extrabold tracking-[-0.055em] text-foreground"
        >
          cc<span className="text-primary">box</span>
        </span>
      )}
    </span>
  );
}
